const columns = [
  {
    "data": "name",
    "className": "bold",
    "width": "45%",
    "render": function (data, type, row, meta) {
      return `<a href='${row['url']}'>${data}</a>`;
    }
  },
  {
    "data": "kind",
    "width": "30%",
    "render": function (data, type, row, meta) {
      return data.charAt(0).toUpperCase() + data.slice(1).replace(/_/g, ' ')
    }
  },
  { data: 'updated_at', width: '15%' },
  {
    "data": "id",
    "width": "10%",
    "render": function (data, type, row, meta) {
      return `<button class='button red small remove-media' data-id='${data}'>Delete</button>`;
    }
  }
]

const headers = [
  'Name',
  'Kind',
  'Updated',
  ''
]

const filters = [
  {
    name: 'Kind', column: 1, kind: 'radio', options: [
      { value: 'image', label: 'Image' },
      { value: 'video', label: 'Video' },
      { value: 'document', label: 'Document' }
    ]
  }
]

const sorters = [
  { column: 2, label: 'Updated', order: 'desc' },
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' }
]

const order = [[0, "asc"]]

export { columns, headers, filters, sorters, order }
